// extracted by mini-css-extract-plugin
module.exports = {"title":"CreateWorkout_title__zBH3V","subtitle":"CreateWorkout_subtitle__1s6Zt"};